// src/pages/JobsByIndustryPage.jsx
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import JobPostJobPage from "../../component/JobPostJobPage";
import Header from "../../component/Header";
import { useFetchData } from "../../hooks/useFtechData"; // fix typo if it's useFetchData
import { ALL_JOB } from "../../resources/resource";
import JobSearchLoader from "../../component/utilities/JobSearchLoader";

function JobsByIndustryPage() {
  const { industry } = useParams();
  const decodedIndustry = decodeURIComponent(industry);

  const { data, loading, error } = useFetchData(ALL_JOB);

  const [jobsInCategory, setJobsInCategory] = useState([]);

  useEffect(() => {
    if (!data) return;

    const filtered = data.filter((job) => {
      // Only show online jobs in this industry
      return (
        job.status === "Online" &&
        job.industry?.toLowerCase() === decodedIndustry.toLowerCase()
      );
    });

    setJobsInCategory(filtered);
  }, [data, decodedIndustry]);

  if (loading) {
    return <JobSearchLoader />;
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-100 pt-20 flex items-center justify-center">
        <div className="text-center p-8 bg-white rounded-lg shadow">
          <h2 className="text-2xl font-bold text-red-600 mb-4">Something went wrong</h2>
          <p className="text-gray-700">{error.message || "Failed to load jobs"}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 pt-16 sm:pt-20">
      <Header darkMode={true} />

      <div className="container mx-auto px-4 py-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 capitalize">
            {decodedIndustry}
          </h1>
          <p className="mt-2 text-gray-600">
            {jobsInCategory.length} {jobsInCategory.length === 1 ? "job" : "jobs"} available
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-8">
          {/* Main content - job listings */}
          <div className="w-full lg:w-2/3">
            {jobsInCategory.length > 0 ? (
              <div className="space-y-6">
                {jobsInCategory.map((job) => (
                  <JobPostJobPage
                    key={job._id}
                    jobId={job._id}
                    position={job.jobTitle}
                    // Fix company name - use populated field or fallback
                    companyName={
                      job.employer?.companyName ||
                      job.employerName ||
                      "Company Name"
                    }
                    location={job.state}
                    salary={job.salary}
                    jobType={job.workType || job.jobType}
                    experience={job.experienceLength}
                    duration={job.expiryDate}           // ← Use expiryDate
                    status="Apply now"
                    contactMail={job.contactMail}
                    localGovernment={job.localGovernment}
                    city={job.city}
                    uniqueViewers={job.uniqueViewers || []}
                    initialLikeCount={job.likeCount || 0}
                    initialFollowCount={job.followCount || 0}
                    isLiked={false}      // ← replace later with real check
                    isFollowing={false}
                  />
                ))}
              </div>
            ) : (
              <div className="bg-white rounded-xl shadow-sm p-10 text-center">
                <h3 className="text-xl md:text-2xl font-semibold text-gray-800 mb-4">
                  No jobs found
                </h3>
                <p className="text-gray-600 max-w-xl mx-auto">
                  There are currently no open positions in <strong>{decodedIndustry}</strong>.
                  <br />
                  Please check back later or explore other categories.
                </p>
              </div>
            )}
          </div>

          {/* Sidebar */}
          <div className="w-full lg:w-1/3">
            <div className="bg-white rounded-xl shadow-sm p-6 sticky top-24">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">
                {decodedIndustry} Jobs
              </h2>
              <div className="p-6 bg-gray-50 rounded-xl text-center">
                <div className="text-4xl font-bold text-orange-600 mb-2">
                  {jobsInCategory.length}
                </div>
                <p className="text-gray-600">open positions</p>
              </div>

              {/* You can add more widgets here later */}
              <div className="mt-6 text-sm text-gray-500">
                <p>Jobs expire based on their plan:</p>
                <ul className="list-disc list-inside mt-2 space-y-1">
                  <li>Basic → 24 hours</li>
                  <li>Standard/Premium → 30 days</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default JobsByIndustryPage;